var _path, _path2, _g, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 56,
    viewBox: "0 0 269 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0855 42H98.5035L99.7635 25.326C99.8895 23.352 99.8055 20.664 99.8055 20.664H99.8895C99.8895 20.664 100.813 23.604 101.527 25.326L106.315 36.876H111.061L115.891 25.326C116.605 23.604 117.487 20.706 117.487 20.706H117.571C117.571 20.706 117.487 23.352 117.613 25.326L118.873 42H124.249L121.855 12.18H116.059L110.221 26.922C109.549 28.686 108.751 31.29 108.751 31.29H108.667C108.667 31.29 107.827 28.686 107.155 26.922L101.317 12.18H95.5215L93.0855 42ZM128.531 31.29C128.531 37.38 132.941 42.504 140.039 42.504C145.373 42.504 148.649 39.438 148.649 39.438L146.591 35.616C146.591 35.616 143.861 37.968 140.417 37.968C137.225 37.968 134.327 36.036 133.991 32.298H148.775C148.775 32.298 148.901 30.87 148.901 30.24C148.901 24.57 145.583 20.076 139.409 20.076C133.025 20.076 128.531 24.696 128.531 31.29ZM134.159 28.644C134.663 25.872 136.553 24.192 139.283 24.192C141.635 24.192 143.441 25.746 143.525 28.644H134.159ZM154.222 34.146C154.222 41.328 160.144 42.21 163.126 42.21C164.134 42.21 164.764 42.084 164.764 42.084V37.422C164.764 37.422 164.386 37.506 163.798 37.506C162.328 37.506 159.556 37.002 159.556 33.474V25.158H164.428V20.916H159.556V14.742H154.348V20.916H151.45V25.158H154.222V34.146ZM169.13 42H174.464V33.516C174.464 32.256 174.59 31.08 174.926 30.03C175.934 26.838 178.496 25.536 180.764 25.536C181.478 25.536 182.024 25.62 182.024 25.62V20.37C182.024 20.37 181.562 20.286 181.058 20.286C177.782 20.286 175.22 22.722 174.254 25.788H174.17C174.17 25.788 174.254 25.074 174.254 24.276V20.58H169.13V42ZM184.023 31.29C184.023 37.884 189.273 42.504 195.825 42.504C202.335 42.504 207.585 37.884 207.585 31.29C207.585 24.738 202.335 20.076 195.783 20.076C189.273 20.076 184.023 24.738 184.023 31.29ZM189.441 31.29C189.441 27.342 192.339 24.612 195.825 24.612C199.269 24.612 202.167 27.342 202.167 31.29C202.167 35.28 199.269 37.968 195.825 37.968C192.339 37.968 189.441 35.28 189.441 31.29ZM211.869 42H217.203V32.172C217.203 31.164 217.287 30.198 217.581 29.316C218.379 26.754 220.479 24.948 223.335 24.948C226.065 24.948 226.737 26.712 226.737 29.316V42H232.029V28.224C232.029 22.554 229.341 20.076 224.595 20.076C220.269 20.076 217.917 22.722 216.993 24.528H216.909C216.909 24.528 216.993 23.856 216.993 23.058V20.58H211.869V42ZM237.627 16.926H242.919V12.18H237.627V16.926ZM237.627 42H242.961V20.58H237.627V42ZM247.27 31.29C247.27 37.506 251.806 42.504 258.904 42.504C264.658 42.504 267.724 39.018 267.724 39.018L265.666 35.238C265.666 35.238 262.978 37.968 259.366 37.968C255.292 37.968 252.688 34.86 252.688 31.248C252.688 27.594 255.25 24.612 259.198 24.612C262.558 24.612 264.784 26.922 264.784 26.922L267.136 23.268C267.136 23.268 264.49 20.076 258.904 20.076C251.806 20.076 247.27 25.2 247.27 31.29Z",
    fill: "#0D2451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.114 2.77686L76.3225 50.1304C77.1517 52.7123 75.2258 55.3535 72.5141 55.3535H61.3307C59.5879 55.3535 58.0457 54.2251 57.5183 52.5641L42.4827 5.21052C41.6637 2.63121 43.5889 0 46.2951 0H57.3056C59.0435 0 60.5826 1.12219 61.114 2.77686Z",
    fill: "#EF305E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5485 37.8L35.8243 3.44919C35.1837 1.39729 33.2837 0 31.1341 0C28.5177 0 26.3602 2.05036 26.227 4.66341L24.9187 30.3392C24.8723 31.2511 24.9823 32.1643 25.244 33.0391L31.0656 52.4999C31.5722 54.1934 33.1302 55.3535 34.8978 55.3535H40.3093C42.0503 55.3535 43.5914 54.2274 44.1203 52.5686L46.5267 45.0214C47.2752 42.6736 47.2828 40.1523 46.5485 37.8Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5485 37.8L35.8243 3.44919C35.1837 1.39729 33.2837 0 31.1341 0C28.5177 0 26.3602 2.05036 26.227 4.66341L24.9187 30.3392C24.8723 31.2511 24.9823 32.1643 25.244 33.0391L31.0656 52.4999C31.5722 54.1934 33.1302 55.3535 34.8978 55.3535H40.3093C42.0503 55.3535 43.5914 54.2274 44.1203 52.5686L46.5267 45.0214C47.2752 42.6736 47.2828 40.1523 46.5485 37.8Z",
    fill: "url(#paint0_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.317 0H31.3316C34.0288 0 35.9529 2.61489 35.1505 5.18995L20.2695 52.9475C19.7487 54.619 18.2014 55.7576 16.4506 55.7576H5.43606C2.73888 55.7576 0.814784 53.1427 1.61716 50.5676L16.4981 2.81005C17.019 1.13856 18.5663 0 20.317 0Z",
    fill: "#EF305E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 24.9083,
    y: 0,
    width: 22.1854,
    height: 55.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.892865 0 0 0 0 0.892865 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29,
    y1: 24.5,
    x2: 49,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.dd5c713c15df3d37957df7130c9622ae.svg";
export { ForwardRef as ReactComponent };